module.exports = __webpack_public_path__ + "img/check_green.8b80502b.svg";